import { paymentMethodsUrl } from "./endpoints.js";
const paymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => [paymentMethodsUrl, { accountId, accountIdType }];
export {
  paymentMethodsCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
